import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-tour',
  templateUrl: './tourfile.component.html',
  styleUrls: ['./tourfile.component.scss']
})
export class TourfileComponent implements OnInit {

  constructor(private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
  }

}
